import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { companiesRef } from './read';
import { companyStatus } from '../../../../constants/enum';

type CompanyStatusValue = (typeof companyStatus)[keyof typeof companyStatus];

/**
 * 企業の契約ステータスを更新する (#2802)
 * - 招待中 ⇄ 利用停止 の切替に使用
 * @param companyId - 対象企業ID
 * @param newStatus - 新しいステータス値 (companyStatus.invited or suspended)
 * @param updatedBy - 操作者の uid
 */
export const updateCompanyStatus = async (
  companyId: string,
  newStatus: CompanyStatusValue,
  updatedBy: string,
): Promise<void> => {
  const companyDoc = doc(companiesRef, companyId);
  await updateDoc(companyDoc, {
    status: newStatus,
    updated_at: serverTimestamp(),
    updated_by: updatedBy,
  });
};
